import React from 'react'
import { createRoot } from 'react-dom/client'
import {
  BrowserRouter, Route, Routes,
} from 'react-router-dom'

import { isLegacySignUpPath, REGISTRATION_URL } from '@dataplace.ai/functions/utils/registration'

const container = document.getElementById('root')
const root = createRoot(container!)

function Redirect() {
  const redirectUrl = isLegacySignUpPath(window.location.pathname)
    ? REGISTRATION_URL
    : `${process.env.NX_WEBAPP3_URL}`

  window.location.replace(redirectUrl)

  return <></>
}

root.render(
  <React.StrictMode>
    <BrowserRouter>
    <Routes>
      <Route
        element={<Redirect />}
        path='*'
      />
    </Routes>
    </BrowserRouter>
  </React.StrictMode>,
)
